<app-material>
    <div class="header" header>
        <h2>{{ 'admin.reasons.table.title' | translate }}</h2>
        <app-button type="primary"
                    *ngIf="shouldRenderModifiers()"
                    (click)="openReasonModal()">
            {{ 'admin.reasons.buttons.addReasons' | translate }}
        </app-button>
    </div>
    <ng-container body>
        <app-reasons-table [reasons]="reasons"
                           [tableConfig]="tableConfig"
                           [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                           [isLoading]="isLoadingReasons"
                           [hasTitle]="false"
                           (sortChange)="onSortChange($event)"
                           (filterChange)="onFilter($event)"
                           (rowClick)="onTableRowClick($event)"
                           (pageChange)="onPageChange($event)">
        </app-reasons-table>
    </ng-container>
</app-material>
<app-reasons-create-modal
    [isLoading]="isLoadingReasons"
    (onCreate)="createReason($event)"
    (onUpdate)="updateReason($event)"
    (onDelete)="deleteReason($event)">
</app-reasons-create-modal>

